import { useEffect } from 'react';

// ─── MODAL PRIVACY POLICY ─────────────────────────────────────────────────────
export function PrivacyPolicyModal({ onClose }: { onClose: () => void }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <div className="sticky top-0 bg-white border-b border-gray-100 px-8 py-5 flex items-center justify-between rounded-t-2xl z-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full" style={{background:'#EEF2FF'}}>
              <i className="ri-shield-user-line text-xl" style={{color:'#1E3A5F'}}></i>
            </div>
            <h2 className="text-lg font-bold text-gray-900">Privacy Policy</h2>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer">
            <i className="ri-close-line text-gray-500 text-xl"></i>
          </button>
        </div>

        <div className="px-8 py-6 space-y-6 text-sm text-gray-700 leading-relaxed">
          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">1. Titolare del Trattamento</h3>
            <p>Il Titolare del trattamento dei dati personali è PM Resources srl, con sede legale in Viale Antonio Ciamarra 222, Roma. Per qualsiasi informazione è possibile contattarci all'indirizzo email: pmresources.srl@gmail.com</p>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">2. Tipologie di Dati Raccolti</h3>
            <p className="mb-2">Raccogliamo e trattiamo le seguenti categorie di dati personali:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Dati identificativi: nome, cognome, ragione sociale</li>
              <li>Dati di contatto: indirizzo email, numero di telefono, indirizzo postale</li>
              <li>Dati professionali: ruolo aziendale, settore di attività</li>
              <li>Dati di navigazione: indirizzo IP, tipo di browser, pagine visitate</li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">3. Finalità del Trattamento</h3>
            <p className="mb-2">I dati personali vengono trattati per le seguenti finalità:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Erogazione dei servizi richiesti e gestione delle richieste di contatto</li>
              <li>Adempimento di obblighi contrattuali e precontrattuali</li>
              <li>Invio di comunicazioni commerciali e promozionali (previo consenso)</li>
              <li>Miglioramento dei servizi offerti e analisi statistiche</li>
              <li>Adempimento di obblighi di legge, contabili e fiscali</li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">4. Base Giuridica del Trattamento</h3>
            <p>Il trattamento dei dati personali si basa su:</p>
            <ul className="list-disc list-inside space-y-1 ml-4 mt-2">
              <li>Esecuzione di un contratto o misure precontrattuali (art. 6.1.b GDPR)</li>
              <li>Consenso esplicito dell'interessato (art. 6.1.a GDPR)</li>
              <li>Legittimo interesse del Titolare (art. 6.1.f GDPR)</li>
              <li>Adempimento di obblighi legali (art. 6.1.c GDPR)</li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">5. Modalità di Trattamento</h3>
            <p>I dati personali sono trattati con strumenti informatici e telematici, con logiche strettamente correlate alle finalità indicate e con l'adozione di misure di sicurezza adeguate per prevenire accessi non autorizzati, divulgazione, modifica o distruzione non autorizzata dei dati.</p>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">6. Conservazione dei Dati</h3>
            <p>I dati personali saranno conservati per il tempo strettamente necessario al conseguimento delle finalità per cui sono stati raccolti e comunque nel rispetto dei termini di legge. I dati raccolti per finalità di marketing saranno conservati fino alla revoca del consenso.</p>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">7. Comunicazione e Diffusione dei Dati</h3>
            <p>I dati personali potranno essere comunicati a:</p>
            <ul className="list-disc list-inside space-y-1 ml-4 mt-2">
              <li>Soggetti che agiscono in qualità di responsabili del trattamento</li>
              <li>Consulenti e professionisti esterni</li>
              <li>Autorità pubbliche e organi di vigilanza, per adempimenti di legge</li>
              <li>Istituti bancari e assicurativi per la gestione amministrativa</li>
            </ul>
            <p className="mt-2">I dati non saranno oggetto di diffusione.</p>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">8. Diritti dell'Interessato</h3>
            <p className="mb-2">L'interessato ha il diritto di:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Accedere ai propri dati personali (art. 15 GDPR)</li>
              <li>Ottenere la rettifica dei dati inesatti (art. 16 GDPR)</li>
              <li>Ottenere la cancellazione dei dati (art. 17 GDPR)</li>
              <li>Ottenere la limitazione del trattamento (art. 18 GDPR)</li>
              <li>Opporsi al trattamento (art. 21 GDPR)</li>
              <li>Richiedere la portabilità dei dati (art. 20 GDPR)</li>
              <li>Revocare il consenso in qualsiasi momento</li>
              <li>Proporre reclamo all'Autorità Garante per la Protezione dei Dati Personali</li>
            </ul>
            <p className="mt-3">Per esercitare i propri diritti, l'interessato può contattarci all'indirizzo: pmresources.srl@gmail.com</p>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">9. Modifiche alla Privacy Policy</h3>
            <p>Il Titolare si riserva il diritto di modificare la presente Privacy Policy in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina con indicazione della data di ultimo aggiornamento.</p>
          </div>

          <div className="pt-4 border-t border-gray-200">
            <p className="text-xs text-gray-500">Ultimo aggiornamento: Gennaio 2025</p>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── MODAL COOKIE POLICY ──────────────────────────────────────────────────────
export function CookiePolicyModal({ onClose }: { onClose: () => void }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <div className="sticky top-0 bg-white border-b border-gray-100 px-8 py-5 flex items-center justify-between rounded-t-2xl z-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full" style={{background:'#EEF2FF'}}>
              <i className="ri-file-shield-2-line text-xl" style={{color:'#1E3A5F'}}></i>
            </div>
            <h2 className="text-lg font-bold text-gray-900">Cookie Policy</h2>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer">
            <i className="ri-close-line text-gray-500 text-xl"></i>
          </button>
        </div>

        <div className="px-8 py-6 space-y-6 text-sm text-gray-700 leading-relaxed">
          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">1. Cosa sono i Cookie</h3>
            <p>I cookie sono piccoli file di testo che i siti web visitati inviano al browser dell'utente, dove vengono memorizzati per essere poi ritrasmessi agli stessi siti alla visita successiva. I cookie sono utilizzati per diverse finalità, per migliorare l'efficienza del sito e per fornire informazioni ai proprietari del sito stesso.</p>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">2. Tipologie di Cookie Utilizzati</h3>
            
            <div className="space-y-4 mt-3">
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Cookie Tecnici</h4>
                <p>Sono cookie necessari al funzionamento del sito e permettono di navigare e utilizzare le funzionalità del sito. Senza questi cookie alcuni servizi non possono essere forniti. Questi cookie non raccolgono informazioni per finalità di marketing e non possono essere disattivati.</p>
                <p className="mt-2 text-xs text-gray-600">Esempi: cookie di sessione, cookie di autenticazione, cookie di sicurezza</p>
              </div>

              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Cookie Analitici</h4>
                <p>Questi cookie raccolgono informazioni su come gli utenti utilizzano il sito web, quali pagine vengono visitate più spesso e se gli utenti ricevono messaggi di errore. Questi cookie non raccolgono informazioni che identificano personalmente l'utente. Tutte le informazioni raccolte sono aggregate e quindi anonime.</p>
                <p className="mt-2 text-xs text-gray-600">Esempi: Google Analytics, statistiche di utilizzo</p>
              </div>

              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Cookie di Profilazione</h4>
                <p>Sono cookie utilizzati per tracciare la navigazione dell'utente in rete e creare profili sui suoi gusti, abitudini, scelte, ecc. Con questi cookie possono essere trasmessi al dispositivo dell'utente messaggi pubblicitari in linea con le preferenze manifestate dallo stesso nell'ambito della navigazione online.</p>
                <p className="mt-2 text-xs text-gray-600">Nota: Questo sito non utilizza cookie di profilazione di terze parti</p>
              </div>

              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Cookie di Terze Parti</h4>
                <p>Alcuni cookie sono installati da terze parti. Il sito non ha controllo sui cookie di terze parti, per maggiori informazioni è necessario consultare i siti web delle terze parti.</p>
                <p className="mt-2 text-xs text-gray-600">Esempi: Google Maps, social media plugin</p>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">3. Durata dei Cookie</h3>
            <p className="mb-2">I cookie possono essere:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li><strong>Cookie di sessione:</strong> vengono cancellati automaticamente alla chiusura del browser</li>
              <li><strong>Cookie persistenti:</strong> rimangono memorizzati sul dispositivo fino alla loro scadenza o cancellazione manuale</li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">4. Come Gestire i Cookie</h3>
            <p className="mb-3">L'utente può decidere se accettare o meno i cookie. La maggior parte dei browser accetta automaticamente i cookie, ma è possibile modificare le impostazioni del browser per rifiutarli.</p>
            
            <div className="space-y-2">
              <p className="font-semibold text-gray-900">Istruzioni per i principali browser:</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li><strong>Chrome:</strong> Impostazioni &gt; Privacy e sicurezza &gt; Cookie e altri dati dei siti</li>
                <li><strong>Firefox:</strong> Opzioni &gt; Privacy e sicurezza &gt; Cookie e dati dei siti web</li>
                <li><strong>Safari:</strong> Preferenze &gt; Privacy &gt; Gestisci dati dei siti web</li>
                <li><strong>Edge:</strong> Impostazioni &gt; Cookie e autorizzazioni sito &gt; Cookie e dati dei siti</li>
              </ul>
            </div>

            <p className="mt-3 text-xs text-gray-600">Nota: La disabilitazione dei cookie tecnici può compromettere il corretto funzionamento del sito.</p>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">5. Cookie Utilizzati da Questo Sito</h3>
            <div className="overflow-x-auto">
              <table className="w-full text-xs border border-gray-200 rounded-lg">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 py-2 text-left font-semibold border-b">Nome</th>
                    <th className="px-3 py-2 text-left font-semibold border-b">Tipo</th>
                    <th className="px-3 py-2 text-left font-semibold border-b">Durata</th>
                    <th className="px-3 py-2 text-left font-semibold border-b">Finalità</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="px-3 py-2">session_id</td>
                    <td className="px-3 py-2">Tecnico</td>
                    <td className="px-3 py-2">Sessione</td>
                    <td className="px-3 py-2">Gestione della sessione utente</td>
                  </tr>
                  <tr className="border-b">
                    <td className="px-3 py-2">_ga</td>
                    <td className="px-3 py-2">Analitico</td>
                    <td className="px-3 py-2">2 anni</td>
                    <td className="px-3 py-2">Google Analytics - statistiche di utilizzo</td>
                  </tr>
                  <tr>
                    <td className="px-3 py-2">cookie_consent</td>
                    <td className="px-3 py-2">Tecnico</td>
                    <td className="px-3 py-2">1 anno</td>
                    <td className="px-3 py-2">Memorizzazione preferenze cookie</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">6. Aggiornamenti</h3>
            <p>La presente Cookie Policy può essere aggiornata periodicamente. Si consiglia di consultare regolarmente questa pagina per essere informati su eventuali modifiche.</p>
          </div>

          <div className="pt-4 border-t border-gray-200">
            <p className="text-xs text-gray-500">Ultimo aggiornamento: Gennaio 2025</p>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── MODAL TERMINI DI SERVIZIO ────────────────────────────────────────────────
export function TermsOfServiceModal({ onClose }: { onClose: () => void }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <div className="sticky top-0 bg-white border-b border-gray-100 px-8 py-5 flex items-center justify-between rounded-t-2xl z-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full" style={{background:'#EEF2FF'}}>
              <i className="ri-file-text-line text-xl" style={{color:'#1E3A5F'}}></i>
            </div>
            <h2 className="text-lg font-bold text-gray-900">Termini di Servizio</h2>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer">
            <i className="ri-close-line text-gray-500 text-xl"></i>
          </button>
        </div>

        <div className="px-8 py-6 space-y-6 text-sm text-gray-700 leading-relaxed">
          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">1. Accettazione dei Termini</h3>
            <p>L'accesso e l'utilizzo di questo sito web comportano l'accettazione dei presenti Termini di Servizio. Se non si accettano questi termini, si prega di non utilizzare il sito. PM Resources srl si riserva il diritto di modificare i presenti termini in qualsiasi momento, pubblicando le modifiche su questa pagina.</p>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">2. Descrizione dei Servizi</h3>
            <p>PM Resources srl offre servizi di consulenza e gestione delle risorse umane, inclusi ma non limitati a:</p>
            <ul className="list-disc list-inside space-y-1 ml-4 mt-2">
              <li>Ricerca e selezione del personale</li>
              <li>Esternalizzazione e gestione del personale</li>
              <li>Consulenza strategica HR</li>
              <li>Formazione professionale</li>
              <li>Temporary management</li>
            </ul>
            <p className="mt-2">I dettagli specifici di ciascun servizio saranno definiti nei singoli contratti o accordi commerciali.</p>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">3. Utilizzo del Sito</h3>
            <p className="mb-2">L'utente si impegna a utilizzare il sito in modo lecito e rispettoso, astenendosi da:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Violare leggi, regolamenti o diritti di terzi</li>
              <li>Trasmettere contenuti illeciti, diffamatori, offensivi o inappropriati</li>
              <li>Tentare di accedere in modo non autorizzato a sistemi o reti</li>
              <li>Interferire con il corretto funzionamento del sito</li>
              <li>Utilizzare il sito per scopi commerciali non autorizzati</li>
              <li>Copiare, modificare o distribuire contenuti senza autorizzazione</li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">4. Proprietà Intellettuale</h3>
            <p>Tutti i contenuti presenti sul sito, inclusi testi, immagini, loghi, grafiche, video e software, sono di proprietà di PM Resources srl o dei rispettivi titolari e sono protetti dalle leggi sul diritto d'autore e sulla proprietà intellettuale.</p>
            <p className="mt-2">È vietata la riproduzione, distribuzione, modifica o utilizzo dei contenuti senza previa autorizzazione scritta del titolare dei diritti.</p>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">5. Limitazione di Responsabilità</h3>
            <p className="mb-2">PM Resources srl non sarà responsabile per:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Interruzioni o malfunzionamenti del sito dovuti a cause tecniche o di forza maggiore</li>
              <li>Danni diretti o indiretti derivanti dall'utilizzo o dall'impossibilità di utilizzare il sito</li>
              <li>Errori, omissioni o imprecisioni nei contenuti pubblicati</li>
              <li>Contenuti o comportamenti di terze parti</li>
              <li>Perdita di dati o informazioni</li>
              <li>Virus o altri elementi dannosi che potrebbero infettare il dispositivo dell'utente</li>
            </ul>
            <p className="mt-2">Il sito è fornito "così com'è" senza garanzie di alcun tipo, esplicite o implicite.</p>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">6. Link a Siti di Terze Parti</h3>
            <p>Il sito può contenere link a siti web di terze parti. PM Resources srl non ha alcun controllo su tali siti e non è responsabile per i loro contenuti, politiche sulla privacy o pratiche. L'accesso a siti di terze parti avviene a rischio e responsabilità dell'utente.</p>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">7. Condizioni Contrattuali</h3>
            <p>I servizi offerti da PM Resources srl sono soggetti a specifici accordi contrattuali che saranno definiti caso per caso. I presenti Termini di Servizio non costituiscono un contratto per la fornitura di servizi professionali, che sarà regolato da appositi documenti contrattuali.</p>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">8. Modifiche ai Servizi</h3>
            <p>PM Resources srl si riserva il diritto di modificare, sospendere o interrompere, temporaneamente o permanentemente, il sito o qualsiasi servizio offerto, con o senza preavviso, senza incorrere in alcuna responsabilità nei confronti dell'utente o di terzi.</p>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">9. Privacy e Protezione dei Dati</h3>
            <p>Il trattamento dei dati personali degli utenti è regolato dalla Privacy Policy del sito, che costituisce parte integrante dei presenti Termini di Servizio. Si invita a consultare la Privacy Policy per informazioni dettagliate sul trattamento dei dati personali.</p>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">10. Legge Applicabile e Foro Competente</h3>
            <p>I presenti Termini di Servizio sono regolati dalla legge italiana. Per qualsiasi controversia relativa all'interpretazione, esecuzione o validità dei presenti termini, sarà competente in via esclusiva il Foro di Roma.</p>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">11. Contatti</h3>
            <p>Per qualsiasi domanda o chiarimento riguardo ai presenti Termini di Servizio, è possibile contattarci:</p>
            <ul className="list-none space-y-1 ml-4 mt-2">
              <li><strong>Email:</strong> pmresources.srl@gmail.com</li>
              <li><strong>Indirizzo:</strong> Viale Antonio Ciamarra 222, Roma</li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-3">12. Separabilità delle Clausole</h3>
            <p>Qualora una o più disposizioni dei presenti Termini di Servizio fossero ritenute invalide o inefficaci, tale invalidità o inefficacia non si estenderà alle altre disposizioni, che rimarranno pienamente valide ed efficaci.</p>
          </div>

          <div className="pt-4 border-t border-gray-200">
            <p className="text-xs text-gray-500">Ultimo aggiornamento: Gennaio 2025</p>
          </div>
        </div>
      </div>
    </div>
  );
}